// Minimum leftover length worth keeping as a reusable piece — mirrors
// ProcessOrdersController::$minLeftoverInches on the backend. Named "inches"
// for historical reasons; the value is in whatever unit the project's
// SIZE_UNIT is configured as (see lib/utils.ts formatSize).
export const MIN_LEFTOVER_INCHES = 100;
